import { Button, notification } from "antd";
import React, { useEffect, useState } from "react";
import API_SERVICE from "shared/services/api-service";
import activeBadge from "../../img/active-badge.png";
import inactiveBadge from "../../img/inactive-badge.png";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import arrowLeft from "../../img/arrow-left.png";
import moment from "moment";
// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

export default function AdminInstructorRating(){
    const {t} = useTranslation();
    const history: any = useHistory();
    const [fetching,setFetching] = useState(false);
    const [items, setItems] = useState([] as any);
    const [lang, setLang] = useState('' as any);

    const refreshItems = () =>{
        setFetching(true);
        API_SERVICE.fetchInsRatingAdmin().then((result) => {
            setItems(result.data.data.items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#insRatingList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                     
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                        "paginate": {
                            "first":      t('genDict.first'),
                            "last":       t('genDict.last'),
                            "next":      t('genDict.next'),
                            "previous":   t('genDict.previous'),
                          },
                          "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                      
                      "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        }).catch((e) => {
            notification.error({ message: API_SERVICE.handleErrors(e) });
            setFetching(false);
        })
        }
    useEffect(() => {
        refreshItems();
        setLang(localStorage.getItem('language'));
    },[]);
    return(
        <div>
            <div className='p-0 mt-3 ml-3 d-flex align-items-center'>
                <div className={lang == 'ar' ? '' : 'mr-4'}>
                    <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                </div>
                <div className={lang == 'ar' ? 'ml-2' : ''}><h3 className='mb-0'>{t('genDict.InsRatingsReviews')}</h3></div>
            </div>
            <div className='bg-white p-3 br-5px mt-3'>
                <div className="row">
                <div className="col-md-12 pb-3">
                    <div className="table-responsive table-br-5 box-shadow mt-2">
                        <table id='insRatingList' className="table table-meetings table-report">
                            <thead>
                                <tr>
                                <th className="text-uppercase text-secondary">{t('adminInsRating.userName')}</th>
                                <th className="text-uppercase text-secondary">{t('adminInsRating.insName')}</th>
                                <th className="text-uppercase text-secondary">{t('adminInsRating.rating')}</th>
                                <th className="text-uppercase text-secondary">{t('adminInsRating.review')}</th>
                                <th className="text-uppercase text-secondary text-center">{t('adminInsRating.status')}</th>
                                <th className="text-uppercase text-secondary">{t('adminInsRating.createdAt')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    items && items.map((item:any) => {
                                        console.log(item);
                                        return <tr>
                                            
                                            <td className="text-secondary">{item?.user?.name}</td>
                                            <td className="text-secondary">{item?.instructor?.name}</td>
                                            <td className="text-secondary">{item?.rating}</td>
                                            <td className="text-secondary">{item?.review}</td>
                                            <td className="text-secondary text-center">
                                                {
                                                    item?.status === 'INACTIVE' ? <Button  className='border-0 p-0' onClick={() => {
                                                        API_SERVICE.activateInsRating(item.id).then(() => {
                                                            refreshItems();
                                                        }).catch((e) => {
                                                            notification.error({ message: API_SERVICE.handleErrors(e) });
                                                        });
                                                    }
                                                    }><img src={inactiveBadge} /></Button> :
                                                    <Button onClick={() => {
                                                        API_SERVICE.deactivateInsRating(item.id).then(() => {
                                                            refreshItems();
                                                        }).catch((e) => {
                                                            notification.error({ message: API_SERVICE.handleErrors(e) });
                                                        });
                                                    }
                                                    } className='border-0 p-0'><img src={activeBadge} /></Button>
                                                }
                                            </td>
                                            <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td>
                                            
                                            
                                            {/* <td className="text-center">
                                                {item.status === 'ACTIVE' ? <img src={activeBadge}/> : <img src={inactiveBadge}/>}
                                            </td>
                                            <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td> */}
                                        </tr>
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

